import { PricingMerchandiseOption, PricingMerchandiseOptionID } from '@kaizenplatform/hugot-entity';

import State from '../core/State';
import initialState from '../initialState';

export const setAvailablePricingMerchandiseOptions = (pricingMerchandiseOptions: PricingMerchandiseOption[]) => (
  state: State,
): State => ({
  ...state,
  pricingMerchandiseOptions: {
    ...state.pricingMerchandiseOptions,
    availablePricingMerchandiseOptions: pricingMerchandiseOptions,
  },
});

export const addSelectedPricingMerchandiseOptionsId = (id: PricingMerchandiseOptionID) => (state: State): State => {
  return {
    ...state,
    pricingMerchandiseOptions: {
      ...state.pricingMerchandiseOptions,
      selectedPricingMerchandiseOptions: state.pricingMerchandiseOptions.selectedPricingMerchandiseOptions.concat([id]),
    },
  };
};

export const removeSelectedPricingMerchandiseOptionsId = (id: PricingMerchandiseOptionID) => (state: State): State => {
  return {
    ...state,
    pricingMerchandiseOptions: {
      ...state.pricingMerchandiseOptions,
      selectedPricingMerchandiseOptions: state.pricingMerchandiseOptions.selectedPricingMerchandiseOptions.filter(
        (optionId) => optionId != id,
      ),
    },
  };
};

export const disposePricingMerchandiseOptions = () => (state: State): State => ({
  ...state,
  pricingMerchandiseOptions: {
    ...initialState.pricingMerchandiseOptions,
  },
});
